import React, { useState, useEffect } from 'react';

 // Import CSS for styling

import { useEmailApi } from '../../auth/helper/api/emailApi';

const EmailAddCorpSenderCredPage = () => {
  
  

  const emailApi = useEmailApi();
  const [credentials, setCredentials] = useState({
    mailHost: '',
    mailPort: 0,
    mailUser: '',
    mailPassword: '',
    mailSmtpAuth: true,
    mailSmtpStarttlsEnable: true,
    createdAt: '',
    lastUpdatedAt:'',
  });
    
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    

    const fetchCredentials = async () => {
      try {
        const response = await emailApi.get(
          process.env
            .REACT_APP_GET_SENDER_EMAIL_CRED_ENDPOINT
        );
        // Extract data from the response
        const { message, object, httpStatus } = response.data;

        if (httpStatus === 200) {
          setCredentials(object || {
            mailHost: '',
            mailPort: 0,
            mailUser: '',
            mailPassword: '',
            mailSmtpAuth: true,
            mailSmtpStarttlsEnable: true,
          }); // Set the cred from the response object
        } else {
          setError(`Error: ${message}`); // Handle non-success status code
        }

        setLoading(false);
      } catch (err) {
        console.error('Error fetching categories:', err);
        setError(err.message || 'An error occurred.');
        setLoading(false);
      }
    };

    fetchCredentials();
  }, [ emailApi]);

  const handleInputChange = (e) => {
    const { name, value, type } = e.target;
    setCredentials((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? e.target.checked : value, // Handle checkbox
    }));
  };

  const handleSubmit = async (e) => {
    

    e.preventDefault();
    try {
      const response = await emailApi.post(
        `${process.env.REACT_APP_SET_SENDER_EMAIL_CRED_ENDPOINT}`,
           credentials
      );
      if (response.status === 200) {
        setSuccess('Email credentials saved successfully!');
        setError(null); // Clear any errors
      } else {
        setError(`Error: ${response.data.message}`);
      }
    } catch (err) {
      setError(err.message || 'An error occurred while saving the credentials.');
      setSuccess(null); // Clear success message
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading categories: {error}</div>;

  return (
    <div className="page-container">
      <h2>Set Email Sender Credentials</h2>

      <form onSubmit={handleSubmit} className="standard-form">
        <div className="form-group">
          <label>Mail Host:</label>
          <input
            type="text"
            name="mailHost"
            value={credentials.mailHost ?? ""}
            onChange={handleInputChange}
            required
          />
        </div>
        
        <div className="form-group">
          <label>Mail Port:</label>
          <input
            type="number"
            name="mailPort"
            value={credentials.mailPort ?? ""}
            onChange={handleInputChange}
            required
          />
        </div>
        
        <div className="form-group">
          <label>Mail User:</label>
          <input
            type="text"
            name="mailUser"
            value={credentials.mailUser ?? ""}
            onChange={handleInputChange}
            required
          />
        </div>
        
        <div className="form-group">
          <label>Mail Password:</label>
          <input
            type="password"
            name="mailPassword"
            value={credentials.mailPassword ?? ""}
            onChange={handleInputChange}
            required
          />
        </div>
        
        <div className="form-group">
          <label>SMTP Authentication:</label>
          <input
            type="checkbox"
            name="mailSmtpAuth"
            checked={credentials.mailSmtpAuth ?? ""}
            onChange={handleInputChange}
          />
        </div>
        
        <div className="form-group">
          <label>Enable STARTTLS:</label>
          <input
            type="checkbox"
            name="mailSmtpStarttlsEnable"
            checked={credentials.mailSmtpStarttlsEnable ?? ""}
            onChange={handleInputChange}
          />
        </div>

         <div className="form-group">
          <label>Created At:</label>
          <input
            type="text"
            name="createdAt"
            value={
              credentials.createdAt
                ? new Date(credentials.createdAt).toLocaleString()
                : ""
            }
            disabled
          />
        </div>

         <div className="form-group">
          <label>Last Updated At:</label>
          <input
            type="text"
            name="lastUpdatedAt"
            value={
              credentials.lastUpdatedAt
                ? new Date(credentials.lastUpdatedAt).toLocaleString()
                : ""
            }
            disabled
          />
        </div>

        <button type="submit">Save Or Edit</button>

        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}
      </form>
    </div>
  );
};

export default EmailAddCorpSenderCredPage;
